export const environment = {
  AUTH_BACKEND: process.env.REACT_APP_AUTH_BACKEND,
  WORKSPACE_BACKEND: process.env.REACT_APP_WORKSPACE_BACKEND,
  API_URL: process.env.REACT_APP_API_URL,
};
